import React from "react";
import _ from "lodash";
import moment from "moment";
import { getShortAddress } from "features/helpers/utils";
import { IconButton } from "@metacrm/metacrm-material-ui/dist/Button";
import { useTheme } from "@mui/styles";
import { getUserAvatarIcon } from "../utils";
import { Box } from "@mui/material";
import IconTooltip from "@metacrm/metacrm-material-ui/dist/IconTooltip";

const Address = ({ user, iconKey = "_id", showExtra = false }) => {
  const theme = useTheme();

  const iconStyle = { borderRadius: 20, marginRight: 5, height: 28, width: 28 };

  const lastEngagementType = _.get(user, "lastEngagement.type", "");
  const lastEngagementTimestamp = _.get(
    user,
    "lastEngagement.date",
    moment().toDate()
  );

  const { wallets, emails, discords, telegrams } = user || {
    wallets: [],
    emails: [],
    discords: [],
    telegrams: [],
  };

  const isNew = moment().diff(moment(lastEngagementTimestamp), "hours") < 1;

  const checkVerifiedStatus = (handle) => {
    if (handle.status === "verified") {
      return (
        <i
          className="meta-crm-icon-ic_check font-size-16"
          style={{ color: "#1FBE0A" }}
        />
      );
    }
    return null;
  };

  if (!user) return <div>-</div>;
  const icon = getUserAvatarIcon(user[iconKey], theme);
  return (
    <div style={{ position: "relative", minWidth: "160px" }}>
      <div
        className="startRow"
        style={{
          color: "#383538",
          fontWeight: 400,
          fontSize: 12,
          display: "flex",
        }}
      >
        <img src={require(`assets/img/${icon}`)} style={iconStyle} />
        <Box ml={"8px"} width="93px">
          {user._id ? (
            <IconTooltip
              customColor="inheritance"
              size="inheritance"
              withoutMaxWidth={true}
              icon={getShortAddress(user._id)}
              content={
                <Box className="startRow">
                  <span>{user._id}</span>

                  <IconButton
                    style={{ padding: 0, marginLeft: 10 }}
                    size={18}
                    onClick={(e) => {
                      navigator.clipboard.writeText(user._id);
                      e.stopPropagation();
                    }}
                  >
                    <i className="meta-crm-icon-ic_copy2 font-size-18" />
                  </IconButton>
                </Box>
              }
            />
          ) : (
            "-"
          )}
          {showExtra && (
            <Box display="flex" alignItems="center">
              {wallets.length > 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: theme.customColors.grey[500],
                    gap: "2px",
                    marginRight: "3px",
                  }}
                >
                  <IconTooltip
                    icon={
                      <i
                        className="meta-crm-icon-ic_wallet-1 font-size-16"
                        style={{
                          color: theme.customColors.grey[500],
                        }}
                      />
                    }
                    content={wallets.map((wallet, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                        }}
                      >
                        {getShortAddress(wallet.walletAddress)}
                        {checkVerifiedStatus(wallet)}
                      </Box>
                    ))}
                  />
                  {wallets.length}
                </Box>
              ) : (
                <i
                  className="meta-crm-icon-ic_wallet-1 font-size-16"
                  style={{
                    color: theme.customColors.grey[300],
                    marginRight: 5,
                  }}
                />
              )}
              {emails.length > 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: theme.customColors.grey[500],
                    gap: "2px",
                    marginRight: "3px",
                  }}
                >
                  <IconTooltip
                    icon={
                      <i
                        className="meta-crm-icon-ic_email font-size-16"
                        style={{
                          color: theme.customColors.grey[500],
                        }}
                      />
                    }
                    content={emails.map((email, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                        }}
                      >
                        {email.handle}
                        {checkVerifiedStatus(email)}
                      </Box>
                    ))}
                  />
                  {emails.length}
                </Box>
              ) : (
                <i
                  className="meta-crm-icon-ic_email font-size-16"
                  style={{
                    color: theme.customColors.grey[300],
                    marginRight: 5,
                  }}
                />
              )}
              {discords.length > 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: theme.customColors.grey[500],
                    gap: "2px",
                    marginRight: "3px",
                  }}
                >
                  <IconTooltip
                    icon={
                      <i
                        className="meta-crm-icon-ic_discord font-size-16"
                        style={{
                          color: theme.customColors.grey[500],
                        }}
                      />
                    }
                    content={discords.map((discord, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                        }}
                      >
                        {discord.handle}
                        {checkVerifiedStatus(discord)}
                      </Box>
                    ))}
                  />
                  {discords.length}
                </Box>
              ) : (
                <i
                  className="meta-crm-icon-ic_discord font-size-16"
                  style={{
                    color: theme.customColors.grey[300],
                    marginRight: 5,
                  }}
                />
              )}
              {telegrams.length > 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: theme.customColors.grey[500],
                    gap: "2px",
                    marginRight: "3px",
                  }}
                >
                  <IconTooltip
                    icon={
                      <i
                        className="meta-crm-icon-ic_telegram font-size-16"
                        style={{
                          color: theme.customColors.grey[500],
                        }}
                      />
                    }
                    content={telegrams.map((telegram, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                        }}
                      >
                        {telegram.handle}
                        {checkVerifiedStatus(telegram)}
                      </Box>
                    ))}
                  />
                  {telegrams.length}
                </Box>
              ) : (
                <i
                  className="meta-crm-icon-ic_telegram font-size-16"
                  style={{
                    color: theme.customColors.grey[300],
                    marginRight: 5,
                  }}
                />
              )}
            </Box>
          )}
        </Box>
        {isNew &&
          (lastEngagementType === "websiteTraffic" ||
            lastEngagementType === "csvImport") && (
            <span
              style={{
                width: "6px",
                height: "6px",
                display: "inline-block",
                background: "#FC5555",
                borderRadius: 40,
                verticalAlign: "middle",
                position: "relative",
                top: "-8px",
                left: "8px",
              }}
            />
          )}
      </div>
    </div>
  );
};

export default Address;
